import styled from 'styled-components';

export const SecureStyled = styled.section`
  padding: 64px 0 0;
  background-color: #212127;
`;

export const Article = styled.article`
  margin-bottom: 56px;

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: 992px) {
    display: grid;
    grid-column: 1/13;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 16px;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const TextBlock = styled.div`
  margin-bottom: 40px;

  @media screen and (min-width: 992px) {
    grid-column: 2/6;
    margin-bottom: 0;

    &.desktop-swap {
      grid-column: 8/12;
      grid-row: 1;
    }
  }
`;

export const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 20px;
  line-height: 1.5;
  color: #ffffff;

  @media screen and (min-width: 992px) {
    margin: 0 0 32px;
    font-size: 32px;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #d0d2d3;

  @media screen and (min-width: 992px) {
    margin-bottom: 24px;
  }
`;

export const Figure = styled.figure`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 992px) {
    grid-column: 8/12;

    &.desktop-swap {
      grid-column: 2/6;
      grid-row: 1;
    }
  }

  img {
    max-width: 100%;
  }

  .desktop {
    display: none;
    @media screen and (min-width: 992px) {
      display: block;
    }
  }

  .mobile {
    display: block;
    @media screen and (min-width: 992px) {
      display: none;
    }
  }
`;

export const TopLogo = styled.span`
  display: none;

  img {
    max-width: 56px;
  }

  @media screen and (min-width: 992px) {
    display: block;
    margin-bottom: 24px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Secure/styled.js